import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import SchemaOrganization from "./SchemaOrganization";

/**
 * avoid using this component directly
 * use `SchemaOrganization.ParentOrganization` instead
 */
var SchemaParentOrganization = function SchemaParentOrganization(props) {
  return /*#__PURE__*/React.createElement(SchemaOrganization, _extends({
    parentOrganization: true
  }, props));
};

SchemaParentOrganization.displayName = "SchemaParentOrganization";
/**
 * TODO:
 * these default props should not be statically set in the component
 * it should be defined by an environment variable, or project config of constants
 * this limits the reusability if the library is distributed
 */

SchemaParentOrganization.defaultProps = {
  name: "Thomson Reuters Corporation",
  url: "https://www.thomsonreuters.com/"
};
export default SchemaParentOrganization;